module.exports = __webpack_public_path__ + "static/media/c2.dc091cd9.png";